import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { EmailAddressAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-email-address-audit-list',
  templateUrl: './person-profile-email-address-audit-list.component.html',
  styleUrls: ['./person-profile-email-address-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileEmailAddressAuditListComponent implements OnInit {
  @Input() emailAddressId: number;
  @Input() loading: boolean;
  @Input() emailAddressAudits: EmailAddressAudit[];

  @Output() loadEmailAddressAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadEmailAddressAudits.emit(this.emailAddressId);
  }

  onNextPage() {
    this.nextPage.emit(this.emailAddressId);
  }
}
